import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ErrorHandlingService } from '../../../../../core/services/error-handling.service';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { ApiResponse } from '../../../../../core/models/api-response.models';
import {
  ExtendedUploadFile,
  QuestionFile,
  QuestionnairesAnswerResponse,
  QuestionnairesPayload,
  QuestionnairesResponse,
} from './questionnaires.interface';

@Injectable({
  providedIn: 'root',
})
export class QuestionnairesService {
  private readonly BASE_URL = `${environment.apiUrl}/organizationquestionnaireresponse`;
  private readonly http = inject(HttpClient);
  private readonly errorHandler = inject(ErrorHandlingService);

  SaveOrUpdateQuestionResponse(
    payload: QuestionnairesPayload
  ): Observable<ApiResponse<QuestionnairesResponse>> {
    return this.http
      .post<
        ApiResponse<QuestionnairesResponse>
      >(`${this.BASE_URL}/save-or-update-questionnaire-response`, payload)
      .pipe(
        tap((response: ApiResponse<QuestionnairesResponse>) => {
          return response;
        }),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  uploadQuestionnaireDocuments(
    attachmentId: number,
    questionId: number,
    files: ExtendedUploadFile[]
  ) {
    const formData = new FormData();
    formData.append('caseAttachmentId', attachmentId.toString());
    formData.append('questionId', questionId.toString());

    const fileIds = files.map(f => f.fileId ?? 0);
    fileIds.forEach(id => {
      formData.append('fileIds', id.toString());
    });
    const fileData = files.map(f => f.originFileObj);
    fileData.forEach(file => {
      formData.append('files', file);
    });

    return this.http
      .post<
        ApiResponse<QuestionFile[]>
      >(`${this.BASE_URL}/upload-questionnaire-files`, formData)
      .pipe(
        tap((response: ApiResponse<QuestionFile[]>) => {
          return response;
        }),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  getQuestionsResponseByAttachmentId(
    attachmentId: number
  ): Observable<ApiResponse<QuestionnairesAnswerResponse[]>> {
    return this.http
      .get<
        ApiResponse<QuestionnairesAnswerResponse[]>
      >(`${this.BASE_URL}/get-organization-questionnaire-responses-by-caseattachementid?caseAttachmentId=${attachmentId}`)
      .pipe(
        tap(response => {
          return response;
        }),
        catchError(error => this.errorHandler.handleError(error))
      );
  }
}
